<template>
    <div>
        <v-card flat>
            <v-alert dense outlined type="error" v-if="alertError">
                No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
            </v-alert>            
            <v-toolbar title elevation="1">
                <v-toolbar-title class="tituloMaquinaria">Tipos de Combustible</v-toolbar-title>
                <v-divider vertical class="ml-3"></v-divider>    

                <v-spacer></v-spacer>      
                <v-text-field outlined class=" pr-4"
                    label="Buscar Tipo Combustible"
                    v-model="buscarTipoCombustible"
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                ></v-text-field>
                <v-tooltip bottom color="#0019d8" v-if="permisos.crear">
                    <template v-slot:activator="{ on }">
                        <v-btn color="#0019d8" @click="AbrirModalRegistrarTipoVehiculo()" dark rounded v-on="on">
                            <v-icon left>fas fa-save</v-icon> Crear
                        </v-btn>
                    </template>
                    <span>Nuevo Tipo Combustible</span>
                </v-tooltip>                                      
            </v-toolbar>
            <v-data-table
                :headers="EncabezadoTablaTipoCombustible"
                :items="ArrayTiposCombustibles"
                class="elevation-1"
                :search="buscarTipoCombustible"
                :footer-props="{itemsPerPageText: 'Filas por página'}"                 
                :loading="loading"
                loading-text="Cargando Datos..."                                
            >
                <template v-slot:item.action="{ item }">
                    <v-tooltip left color="#d69b01">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark fab color="#d69b01" v-on="on" @click="AbrirModalEditarTipoCombustible(item)">
                                <v-icon small>fas fa-edit</v-icon>
                            </v-btn>                        
                        </template>
                        <span class="fontButton">Editar Tipo Combustible</span>
                    </v-tooltip>                                              
                    <v-tooltip left color="#D80000" v-if="permisos.eliminar">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark fab color="#D80000" v-on="on" @click="AbrirModalEliminarTipoVehiculo(item)">
                                <v-icon small>fas fa-trash-alt</v-icon>
                            </v-btn>                        
                        </template>
                        <span class="fontButton">Eliminar Tipo Combustible</span>
                    </v-tooltip>                                              
                </template>            
                <template v-slot:no-results>
                    <v-alert type="warning" prominent dense outlined border="left" class="text-xs-center mx-10 mt-2 titulo">
                        Tipo de Combustible no existe
                    </v-alert>                        
                </template>                
                <template v-slot:no-data v-if="ArrayTiposCombustibles.length === 0">
                    <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left" v-if="!alertError">
                        No existen Tipos de Combustible registrados
                    </v-alert>
                    <v-alert dense outlined type="error" v-if="alertError">
                        No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
                    </v-alert>
                </template>                                
            </v-data-table>
        </v-card>
        <!-- mostramos el circular progress cuando carguen los datos para editar un tipo de Combustible -->
        <v-overlay :value="EstadoCircularProgress">
            <v-progress-circular indeterminate :size="80" :width="10" color="#ffffff"></v-progress-circular>
        </v-overlay>                      
        <RegistrarTipoCombustible 
            :AbrirDialogoRegistrarTipoCombustible="AbrirDialogoRegistrarTipoCombustible" @CerrarModalRegistrarTipoCombustible="CerrarModalRegistrarTipoCombustible"
            :esNuevo="esNuevo" :TituloDialogo="TituloDialogo" @TodosTiposCombustible="TodosTiposCombustible"
            :DatosEditarTipoCombustible="DatosEditarTipoCombustible" :EstadoPermisoEditar="EstadoPermisoEditar"
        />
        <MensajeEliminar 
            :DialogoMensajeEliminar="DialogoMensajeEliminar" @CerrarDialogoMensajeEliminar="CerrarDialogoMensajeEliminar"
            :tituloMensajeEliminar="tituloMensajeEliminar" @Eliminar="EliminarTipoCombustible"
            :loadingEliminarHerramientaMateriaPrima="loadingEliminarTipoCombustible" :alertError="alertError"
        />        
    </div>    
</template>

<script>
import { mapGetters, mapActions  } from 'vuex'
import { showMessageError, showMessageSuccess } from '../../../../services/sweetAlert'
import RegistrarTipoCombustible from '../../../../components/IngresoNuevaInformacion/Tipos/TipoCombustible/RegistrarTipoCombustible'
import MensajeEliminar from '../../../../components/MensajeEliminar'

export default {
    props: {
        tab: String
    },

    components: {
        RegistrarTipoCombustible,
        MensajeEliminar,
    },
    data() {
        return {
            EncabezadoTablaTipoCombustible:[
                {text: 'Tipo Combustible', value: 'nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                // {text: 'Descripción', value: 'descripcion', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Acciones', value: 'action', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],                   
            buscarTipoCombustible:'',
            ArrayTiposCombustibles:[],
            loading:false,
            alertError:false,
            //variables para los permisos del colaborador
            namespace:'oidcStore/',
            EstadoPermisoEditar: false,
            permisos:{
                crear:false,
                editar:false,
                eliminar:false
            },
            // nuevo tipo de combustible
            esNuevo: false,
            TituloDialogo:'',
            AbrirDialogoRegistrarTipoCombustible: false,
            // eliminar tipo de combustible
            DialogoMensajeEliminar:false,
            tituloMensajeEliminar:'',
            loadingEliminarTipoCombustible: false,
            IdTipoFuel: '',
            // editar tipo de combustible
            DatosEditarTipoCombustible:{},
            EstadoCircularProgress:false,
        }
    },

    computed: {
        ...mapGetters('oidcStore', [
            'oidcIsAuthenticated',
            'oidcUser'
        ]),      
    },    

    watch: {
        tab(){
            if(this.tab==="tab-5")this.TodosTiposCombustible()
        }
    },

    created() {
        this.TodosTiposCombustible()
        this.ObtenerPermisosSubmenuUsuario()
    },

    methods: {
        // metodos para obtener los permisos del colaborador a este modulo
            ...mapActions('oidcStore', ['authenticateOidcSilent',
                    'signOutOidc', 'authenticateOidc']),
            async ObtenerPermisosSubmenuUsuario(role){
                if (this.$store.getters[this.namespace + 'oidcIsAuthenticated']) {
                    if(this.$store.getters['oidcStore/oidcUser'].role === 'Administrador'){
                            this.permisos.crear = true
                            this.permisos.editar = true
                            this.permisos.eliminar = true
                            return 0            
                    }else{
                        //preguntar al backend por los permisos del submenu del usuario
                            var url = 'tipo'
                            const response  = await this.$store.dispatch('PermisosSubMenu', url)
                            if(typeof response === 'undefined'){
                                this.alertError=true
                                this.loading=false
                                return 0
                            }                                                 
                            if(response.status === 200){
                                this.alertError= false
                                this.permisos = response.data         
                            }else if(response.status === 400){
                                showMessageError('Error 400','Petición mala')
                            }else if(response.status === 404){
                                showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                            }else if(response.status === 500){
                                showMessageError('Error 500','Error en el servidor')            
                            }
                            return 0
                    }
                }
            },                    
        // controlamos las excepciones de las peticiones al api
            ControllerException(response){
                if(typeof response === 'undefined'){
                    this.alertError=true
                    this.loading = false
                    this.EstadoCircularProgress = false
                    this.loadingEliminarTipoCombustible = false
                    return 0
                }if(response.status === 200){
                    this.alertError= false
                    this.loading = false                    
                    if(this.TituloDialogo === "eliminar"){
                        showMessageSuccess('¡BIEN!', 'Tipo combustible eliminado correctamente')
                        this.TituloDialogo = ''
                        this.TodosTiposCombustible()
                        this.loadingEliminarTipoCombustible = false
                        this.CerrarDialogoMensajeEliminar()
                    }else if(this.TituloDialogo === "Editar"){
                        if(this.permisos.editar) this.EstadoPermisoEditar = this.permisos.editar
                        else this.EstadoPermisoEditar = this.permisos.editar
                        this.DatosEditarTipoCombustible = response.data
                        this.EstadoCircularProgress = false
                        this.AbrirDialogoRegistrarTipoCombustible = true
                    }else{
                        // console.log(response.data)
                        this.ArrayTiposCombustibles = response.data
                    }
                }else if(response.status === 400){
                    showMessageError('Error 400','Petición mala')
                    this.loadingEliminarTipoCombustible = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 401){
                    showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                    this.loadingEliminarTipoCombustible = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 404){
                    showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                    this.loadingEliminarTipoCombustible = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 500){
                    showMessageError('Error 500','Error en el servidor')            
                    this.loadingEliminarTipoCombustible = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }
            },

        // obtenemos todas los tipos de combustible
            async TodosTiposCombustible(){
                this.loading = true
                const response = await this.$store.dispatch('getAllTypesFuel')
                // controlamos las excepciones
                this.ControllerException(response)            
            },
        //metodos para registrar un nuevo tipo de incidente
            AbrirModalRegistrarTipoVehiculo(){
                if(this.permisos.crear) this.EstadoPermisoEditar = this.permisos.crear
                this.esNuevo = true
                this.TituloDialogo = "Crear"
                this.AbrirDialogoRegistrarTipoCombustible = true
            },
            CerrarModalRegistrarTipoCombustible(){
                this.TituloDialogo = ''
                this.AbrirDialogoRegistrarTipoCombustible = false
            },
        //metodos para eliminar un tipo de incidente
            AbrirModalEliminarTipoVehiculo(item){
                this.TituloDialogo = "eliminar"
                this.tituloMensajeEliminar = item.nombre
                this.IdTipoFuel = item.idTipoCombustible
                // console.log(item)
                this.DialogoMensajeEliminar = true
            },
            CerrarDialogoMensajeEliminar(){
                this.DialogoMensajeEliminar = false
            },
            async EliminarTipoCombustible(){
                this.loadingEliminarTipoCombustible = true
                const response = await this.$store.dispatch('DeleteTypeFuel', this.IdTipoFuel)
                this.ControllerException(response)
            },
        // metodos para editar un tipo de combustible
            async AbrirModalEditarTipoCombustible(item){
                this.EstadoCircularProgress = true
                const response = await this.$store.dispatch('GetTypeFuelById', item.idTipoCombustible)
                this.esNuevo = false
                this.TituloDialogo = "Editar"
                this.ControllerException(response)
            }
    },
}
</script>